import {
  AlertCircle,
  ArchiveRestore,
  ArchiveX,
  ArrowDownWideNarrow,
  ArrowLeft,
  ArrowUpDown,
  ArrowUpWideNarrow,
  BarChart,
  Blocks,
  BookOpenCheck,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsUpDown,
  CircleCheck,
  CircleHelp,
  CircleX,
  ClipboardCheck,
  Copy,
  CopyPlus,
  CornerDownLeft,
  EllipsisVertical,
  ExternalLink,
  Flag,
  Folder,
  FolderInput,
  FolderOpen,
  FolderPen,
  FolderPlus,
  FolderX,
  Gauge,
  Gem,
  Goal,
  GripVertical,
  History,
  Info,
  Laptop,
  Link,
  ListChecks,
  Lock,
  LogOut,
  Maximize2,
  Megaphone,
  MessageCircle,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  Origami,
  Pause,
  Pencil,
  PencilRuler,
  Phone,
  PhoneOutgoing,
  Play,
  Plug,
  Plus,
  RotateCcw,
  RotateCw,
  Search,
  SearchCheck,
  Send,
  Settings,
  Share2,
  SquareLibrary,
  SquareTerminal,
  Star,
  Table,
  Tag,
  Tally5,
  ThumbsDown,
  ThumbsUp,
  TrafficCone,
  Trash2,
  TriangleAlert,
  Upload,
  UserRound,
  UserRoundPlus,
  UserRoundSearch,
  UsersRound,
  WandSparkles,
  WifiOff,
  X,
  Zap,
} from 'lucide-react';
import { ReactComponent as ForYou } from '../../../assets/for-you-icon.svg';
import { ReactComponent as GongIcon } from '../../../assets/gong-icon.svg';
import { ReactComponent as GongLightIcon } from '../../../assets/gong-light-icon.svg';
import { ReactComponent as FlagCircleOutlined } from '../../../assets/mui-flag-icon.svg';
import { ReactComponent as Objections } from '../../../assets/objections-icon.svg';
import { ReactComponent as Questions } from '../../../assets/questions-icon.svg';
import { ReactComponent as SalesloftIcon } from '../../../assets/salesloft-icon.svg';
import { ReactComponent as SalesloftLightIcon } from '../../../assets/salesloft-light-icon.svg';
import { ComponentSize, SemanticColor, TagColor, TextColor } from '../../../types';
import { Icon, IconColor } from './Icons.types';

export const ICON_MAP = {
  [Icon.ARCHIVE]: ArchiveX,
  [Icon.ARROW_SORT_ASC]: ArrowUpWideNarrow,
  [Icon.ARROW_SORT_DESC]: ArrowDownWideNarrow,
  [Icon.ARROW_SORT_NONE]: ArrowUpDown,
  [Icon.BAR_CHART]: BarChart,
  [Icon.CHECK]: Check,
  [Icon.CHEVRON_DOWN]: ChevronDown,
  [Icon.CHEVRON_LEFT]: ChevronLeft,
  [Icon.CHEVRON_RIGHT]: ChevronRight,
  [Icon.CHEVRON_UP]: ChevronUp,
  [Icon.CHEVRONS_UP_DOWN]: ChevronsUpDown,
  [Icon.CIRCLE_ALERT]: AlertCircle,
  [Icon.CIRCLE_CHECK]: CircleCheck,
  [Icon.CIRCLE_HELP]: CircleHelp,
  [Icon.CIRCLE_X]: CircleX,
  [Icon.COACHING]: Megaphone,
  [Icon.CLOSE]: X,
  [Icon.COMMENT]: MessageCircle,
  [Icon.COPY]: Copy,
  [Icon.CORNER_DOWN_LEFT]: CornerDownLeft,
  [Icon.DRAFT]: PencilRuler,
  [Icon.DUPLICATE]: CopyPlus,
  [Icon.EDIT]: Pencil,
  [Icon.ELLIPSIS_VERTICAL]: EllipsisVertical,
  [Icon.FAST_FORWARD]: RotateCw,
  [Icon.FLAG]: FlagCircleOutlined,
  [Icon.FOLDER]: Folder,
  [Icon.FOLDER_DELETE]: FolderX,
  [Icon.FOLDER_EDIT]: FolderPen,
  [Icon.FOLDER_MOVE]: FolderInput,
  [Icon.FOLDER_OPEN]: FolderOpen,
  [Icon.FOLDER_PLUS]: FolderPlus,
  [Icon.FOR_YOU]: ForYou,
  [Icon.GRIP_VERTICAL]: GripVertical,
  [Icon.GONG]: GongIcon,
  [Icon.GONG_LIGHT]: GongLightIcon,
  [Icon.HIDDEN_GEMS]: Gem,
  [Icon.HISTORY]: History,
  [Icon.INFO]: Info,
  [Icon.INTEGRATIONS]: Blocks,
  [Icon.KNOWLEDGE_HUB]: BookOpenCheck,
  [Icon.LAPTOP]: Laptop,
  [Icon.LIBRARY]: SquareLibrary,
  [Icon.LINK]: Link,
  [Icon.LIST_CHECKS]: ListChecks,
  [Icon.LOCK]: Lock,
  [Icon.LOG_OUT]: LogOut,
  [Icon.MAXIMIZE]: Maximize2,
  [Icon.MINIMIZE]: Minimize2,
  [Icon.MIC_ON]: Mic,
  [Icon.MIC_OFF]: MicOff,
  [Icon.MINUS]: Minus,
  [Icon.OBJECTIONS]: Objections,
  [Icon.OPEN]: ExternalLink,
  [Icon.ORIGAMI]: Origami,
  [Icon.PAUSE]: Pause,
  [Icon.PLUG]: Plug,
  [Icon.PLAY]: Play,
  [Icon.PHONE]: Phone,
  [Icon.PHONE_OUTGOING]: PhoneOutgoing,
  [Icon.PLUS]: Plus,
  [Icon.PRIORITIES]: Goal,
  [Icon.QUESTIONS]: Questions,
  [Icon.REPORT]: Flag,
  [Icon.REWIND]: RotateCcw,
  [Icon.SCORECARD]: ClipboardCheck,
  [Icon.SEARCH]: Search,
  [Icon.SEARCH_CHECK]: SearchCheck,
  [Icon.SEND]: Send,
  [Icon.SETTINGS]: Settings,
  [Icon.SHARE]: Share2,
  [Icon.SPEED]: Gauge,
  [Icon.SQUARE_TERMINAL]: SquareTerminal,
  [Icon.STAR]: Star,
  [Icon.TABLE_VIEW]: Table,
  [Icon.TAG]: Tag,
  [Icon.TALLY]: Tally5,
  [Icon.THUMBS_DOWN]: ThumbsDown,
  [Icon.THUMBS_UP]: ThumbsUp,
  [Icon.TRASH]: Trash2,
  [Icon.TRIANGLE_ALERT]: TriangleAlert,
  [Icon.UNARCHIVE]: ArchiveRestore,
  [Icon.USER]: UserRound,
  [Icon.USERS]: UsersRound,
  [Icon.USER_PLUS]: UserRoundPlus,
  [Icon.USER_SEARCH]: UserRoundSearch,
  [Icon.WIFI_OFF]: WifiOff,
  [Icon.UPLOAD]: Upload,
  [Icon.TRAFFIC_CONE]: TrafficCone,
  [Icon.WAND]: WandSparkles,
  [Icon.ZEUS]: Zap,
  [Icon.ARROW_LEFT]: ArrowLeft,
  [Icon.SALESLOFT]: SalesloftIcon,
  [Icon.SALESLOFT_LIGHT]: SalesloftLightIcon,
};

export const ICON_SIZE: Record<ComponentSize, number> = {
  [ComponentSize.X_SMALL]: 14,
  [ComponentSize.SMALL]: 16,
  [ComponentSize.MEDIUM]: 20,
  [ComponentSize.LARGE]: 24,
};

/** Maps icon colors to stroke color classes. */
export const ICON_COLOR_TO_STROKE_COLOR: Record<IconColor, string> = {
  [TagColor.RED]: 'stroke-tags-red',
  [TagColor.PINK]: 'stroke-tags-pink',
  [TagColor.PURPLE]: 'stroke-tags-purple',
  [TagColor.INDIGO]: 'stroke-tags-indigo',
  [TagColor.LIGHT_BLUE]: 'stroke-tags-light-blue',
  [TagColor.TEAL]: 'stroke-tags-teal',
  [TagColor.LIME]: 'stroke-tags-lime',
  [TagColor.YELLOW]: 'stroke-tags-yellow',
  [TagColor.ORANGE]: 'stroke-tags-orange',
  [TextColor.DESTRUCTIVE]: 'stroke-error',
  [TextColor.LINK]: 'stroke-secondary',
  [TextColor.PRIMARY]: 'stroke-base-content',
  [TextColor.SECONDARY]: 'stroke-base-content/60',
  [TextColor.TERTIARY]: 'stroke-base-content/30',
  [TextColor.INVERSE]: 'stroke-white',
  [SemanticColor.PRIMARY]: 'stroke-primary',
  [SemanticColor.SECONDARY]: 'stroke-secondary',
  [SemanticColor.ACCENT]: 'stroke-accent',
};

/** Maps icon colors to fill color classes. */
export const ICON_COLOR_TO_FILL_COLOR: Record<IconColor, string> = {
  [TagColor.RED]: 'fill-tags-red',
  [TagColor.PINK]: 'fill-tags-pink',
  [TagColor.PURPLE]: 'fill-tags-purple',
  [TagColor.INDIGO]: 'fill-tags-indigo',
  [TagColor.LIGHT_BLUE]: 'fill-tags-light-blue',
  [TagColor.TEAL]: 'fill-tags-teal',
  [TagColor.LIME]: 'fill-tags-lime',
  [TagColor.YELLOW]: 'fill-tags-yellow',
  [TagColor.ORANGE]: 'fill-tags-orange',
  [TextColor.DESTRUCTIVE]: 'fill-error',
  [TextColor.LINK]: 'fill-secondary',
  [TextColor.PRIMARY]: 'fill-base-content',
  [TextColor.SECONDARY]: 'fill-base-content/60',
  [TextColor.TERTIARY]: 'fill-base-content/30',
  [TextColor.INVERSE]: 'fill-white',
  [SemanticColor.PRIMARY]: 'fill-primary',
  [SemanticColor.SECONDARY]: 'fill-secondary',
  [SemanticColor.ACCENT]: 'fill-accent',
};
